import React from 'react';

import { WidgetAccount as WidgetAccountBare } from '@interlayer/js/app/components/common/WidgetAccount/WidgetAccount';

import { componentService } from '@core/js/services/component.service';

import { TWidgetAccountProps } from '@interlayer/js/app/components/common/WidgetAccount/types';

export const WidgetAccount: React.FC<TWidgetAccountProps> = (props) => <WidgetAccountBare {...props} isCasinoEnv />;

componentService.registerWebContentComponents({ WidgetAccount });
